import { handleActions } from 'redux-actions'
import * as aiActions from '../actions'

const defaultState = []

export default handleActions(
  {
    [aiActions.getPredictionSets.success](state, { response }) {
      return response.data
    },
    [aiActions.deletePredictionSet.success](state, { payload: predictionSetId }) {
      return state.filter((prSet) => prSet.Id !== predictionSetId)
    },
    [aiActions.publishAiModel.success](state, { payload: { aiModelId, tenants } }) {
      return state.map((prSet) =>
        prSet.AIModelId === aiModelId
          ? { ...prSet, PublishedToTenants: [...prSet.PublishedToTenants, ...tenants] }
          : prSet
      )
    },
    [aiActions.unpublishAiModel.success](state, { payload: { aiModelId, tenants } }) {
      return state.map((prSet) =>
        prSet.AIModelId === aiModelId
          ? {
              ...prSet,
              PublishedToTenants: prSet.PublishedToTenants.filter((tenant) => !tenants.some((t) => t.Id === tenant.Id)),
            }
          : prSet
      )
    },
    [aiActions.resetState](state, payload) {
      return defaultState
    },
  },
  defaultState
)
